import PartnerVehicleRecords from './PartnerVehicleRecords';

interface Props {
    partnerId: number;
}

export default function PartnerProcurementTab({ partnerId }: Props) {
    return (
        <div className="space-y-6">
            <PartnerVehicleRecords partnerId={partnerId} group="procurement" />
        </div>
    );
}
